import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-daily-sales-report',
  templateUrl: './daily-sales-report.component.html',
  styleUrls: ['./daily-sales-report.component.scss']
})
export class DailySalesReportComponent {
  public shareSplit: any;

  public filterMonth:any;
  public weeks:any = [];
  public months:any = [];
  public is_mario:boolean = false;
  public other_profit:any = [];
  public total_profit:any = 0;
  public todays:any = {}
  public today_date:any;
  public summary_checked:boolean = false;
  public permission:any = {};
  public configuration:any = {}
  public is_saving = false;
  public capital:any = {}
  public other:any = {}
  public updateBalanceTimeout:any = null;
  public debug:any = {};
  constructor(private http: HttpService, private cdr: ChangeDetectorRef, private ngbModal:NgbModal) { 
    this.getConfiguration();
    let today = new Date();
    let lm = (new Date());
    lm.setMonth(today.getMonth() - 1)
    this.filterMonth = today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2);

    this.months = [{
        value: today.getFullYear() + "-" + ("0" + (today.getMonth() + 1)).slice(-2),
        label: ("0" + (today.getMonth() + 1)).slice(-2) + "-" + today.getFullYear()
      },
      {
        value: lm.getFullYear() + "-" + ("0" + (lm.getMonth() + 1)).slice(-2),
        label: ("0" + (lm.getMonth() + 1)).slice(-2) + "-" + lm.getFullYear()
      }
    ]

    today.setHours(0,0,0,0)
    this.today_date = today;

    let access:any = this.http.getAccess();
    if (access.is_mario) {
      this.is_mario = access.is_mario == "1" ? true : false;
    }

    this.http.getSelectedCompany().subscribe(async (v) => {

      if(v) {

        this.permission = await this.http.getHiddenPermission();
        this.monthChange(this.filterMonth);

      }
    });    

  }

  public async getConfiguration() {
    let rtn:any = await this.http.post("/admin/company/setting");
    this.configuration = rtn.setting;
  }

  async monthChange(dt:any) {

    let month = this.filterMonth;
    this.weeks = []
    if(dt instanceof Event) {
      month = (dt.target as any).value;
    }

    this.summary_checked = false;
    let y:any = await this.http.post("/admin/daily-sales-report/get", {period: month});

    this.weeks = y.data;
    this.shareSplit = y.share_split;

    this.summary_checked = y.summary_checked;

    await this.getCapital();
    await this.getOtherProfit();

    this.cdr.detectChanges();
  }

  sum(key, arr) {
    let val = arr.map((v:any) => {
      return parseFloat(v[key] ?? 0)
    })

    return val.reduce((partialSum, a) => parseFloat(partialSum) + parseFloat(a), 0);
  }

  async updateBalance(day:any, is_checked:boolean = true) {

    // day.balance = parseFloat(day.debit ?? 0) - parseFloat(day.credit ?? 0) + parseFloat(day.daily_adj_in ?? 0) - parseFloat(day.daily_adj_out ?? 0)

    if (this.updateBalanceTimeout) {
      clearTimeout(this.updateBalanceTimeout);
    }

    this.updateBalanceTimeout = setTimeout(async () => {
      this.is_saving = true;
      await this.http.post("/admin/daily-sales-report/save", {period: this.filterMonth, day: day})
      this.is_saving = false;
      this.monthChange(this.filterMonth);
    }, is_checked ? 1500 : 0);
  }
 
  async save() {
    this.is_saving = true;
    await this.http.post("/admin/daily-sales-report/save", {period: this.filterMonth, data: this.weeks})
    this.is_saving = false;
    this.monthChange(this.filterMonth);
  }

  flattern(weeks) {
    return weeks.flat();
  }

  isFutureDate(date:string) {
    let sd = (new Date(date)).setHours(0,0,0,0)
    return this.today_date <= sd
  }

  async getCapital() {
    this.capital = await this.http.post("/admin/capital/get", {period: this.filterMonth});
  }

  async saveCapital() {
    await this.http.post("/admin/capital/save", {...this.capital, period: this.filterMonth});
    this.getCapital();
  }

  async getOtherProfit() {
    let others:any = await this.http.post("/admin/other-profit/get", {period: this.filterMonth});
    this.other_profit = others.collection;
    this.sumOtherProfit();
  }

  async saveOtherProfit() {
    await this.http.post("/admin/other-profit/save", {...this.other, period: this.filterMonth});
    this.other = {}
    await this.monthChange(this.filterMonth);
  }

  async removeOtherProfit(id) {
    await this.http.post("/admin/other-profit/remove", {id})
    this.other = {}
    await this.monthChange(this.filterMonth);
  }

  sumOtherProfit() {
    let total = 0; 
    for(var x = 0; x < this.other_profit.length; x++) {
      total = total + parseFloat(this.other_profit[x].debit ?? 0) - parseFloat(this.other_profit[x].credit ?? 0)
    }
    this.total_profit = total;
  }

  displayDebug(content, day:any) {

    let data = day.data;
    let y = "<table>"
    let dataKeys = Object.keys(data);
    for(let i = 0; i < dataKeys.length; i++) {
      let d = dataKeys[i];
      y += "<tr><td>" + d + "</td><td>" + data[d] + "</td></tr>";
    }
    y += "</table>";
    this.debug = y;
    // Open popup window
    this.ngbModal.open(content)

  }
}
